import {
  dateOfBirthSchema,
  dateOfBirthUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SupplementalApplicantDescription from '../../components/FormDescriptions/SupplementalApplicantDescription';
import {
  DEFAULT_TITLE_OPTS,
  fullNameSchema,
  fullNameUI,
  titleWithRoleUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['supplemental--applicant-personal-info-title'];

export default {
  uiSchema: {
    ...titleWithRoleUI(
      TITLE_TEXT,
      SupplementalApplicantDescription,
      DEFAULT_TITLE_OPTS.beneficiary,
    ),
    applicantName: fullNameUI(),
    applicantDob: dateOfBirthUI(),
  },
  schema: {
    type: 'object',
    required: ['applicantName', 'applicantDob'],
    properties: {
      applicantName: fullNameSchema,
      applicantDob: dateOfBirthSchema,
    },
  },
};
